var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._b({attrs:{"loading":_vm.loading}},'img',_vm.rootAttrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }